import { Injectable } from '@angular/core';

import { ControlData, ControlDetail } from '../shared/app-consts';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  filterBySearchText(filteredResults: ControlData[], searchText: string): ControlData[] {
    return filteredResults.filter(control =>
      control.ControlID.toLowerCase().startsWith(searchText.toLowerCase())
    );
  }
  filterServicesAndStatuses(filteredResults: ControlData[], selectedServices: { [service: string]: boolean }, selectedStatuses: { [status: string]: boolean }): ControlData[] {
    filteredResults = this.filterBySelectedServices(filteredResults, selectedServices);
    filteredResults = this.filterBySelectedStatuses(filteredResults, selectedStatuses);
    return filteredResults;
  }

  filterBySelectedServices(filteredResults: ControlData[], selectedServices: { [service: string]: boolean }): ControlData[] {
    if (Object.values(selectedServices).some(service => service)) {
      filteredResults = filteredResults.filter(control =>
        selectedServices[this.getServiceName(control.ControlID)]
      );
    }
    return filteredResults;
  }
  filterBySelectedStatuses(filteredResults: ControlData[], selectedStatuses: { [status: string]: boolean }): ControlData[] {
    if (selectedStatuses['申請済み']) {
      filteredResults = filteredResults.filter(control => control.ApplicationCount !== undefined && control.ApplicationCount >= 1);
    }

    if (selectedStatuses['未完了'] && selectedStatuses['完了']) {
      filteredResults = filteredResults.filter(control => control.Status == 0 || control.Status == 1 || control.Status == 2 || control.Status == 3 || control.Status == 4);
    } else if (selectedStatuses['未完了']) {
      filteredResults = filteredResults.filter(control => control.Status == 0 || control.Status == 1 || control.Status == 2 || control.Status == 3);
    } else if (selectedStatuses['完了']) {
      filteredResults = filteredResults.filter(control => control.Status === 4);
    }
    return filteredResults;
  }
  getServiceName(controlId: string): string {
    return controlId.split('.')[0];
  }
  constructor() { }

  // control list
  filterBySearchTextB(filteredResults: ControlDetail[], searchText: string): ControlDetail[] {
    return filteredResults.filter(control =>
      control.ControlID.toLowerCase().startsWith(searchText.toLowerCase())
    );
  }

  filterServicesAndStatusesB(filteredResults: ControlDetail[], selectedServices: { [service: string]: boolean }, selectedStatuses: { [status: string]: boolean }): ControlDetail[] {
    filteredResults = this.filterBySelectedServicesB(filteredResults, selectedServices);
    filteredResults = this.filterBySelectedStatusesB(filteredResults, selectedStatuses);
    return filteredResults;
  }
  filterBySelectedServicesB(filteredResults: ControlDetail[], selectedServices: { [service: string]: boolean }): ControlDetail[] {
    if (Object.values(selectedServices).some(service => service)) {
      filteredResults = filteredResults.filter(control =>
        selectedServices[this.getServiceName(control.ControlID)]
      );
    }
    return filteredResults;
  }
  filterBySelectedStatusesB(filteredResults: ControlDetail[], selectedStatuses: { [status: string]: boolean }): ControlDetail[] {
    if (selectedStatuses['申請済み']) {
      filteredResults = filteredResults.filter(control => control.ApplicationCount !== undefined && control.ApplicationCount >= 1);
    }

    if (selectedStatuses['未完了'] && selectedStatuses['完了']) {
      filteredResults = filteredResults.filter(control => control.Status == 0 || control.Status == 1 || control.Status == 2 || control.Status == 3 || control.Status == 4);
    } else if (selectedStatuses['未完了']) {
      filteredResults = filteredResults.filter(control => control.Status == 0 || control.Status == 1 || control.Status == 2 || control.Status == 3);
    } else if (selectedStatuses['完了']) {
      filteredResults = filteredResults.filter(control => control.Status === 4);
    }
    return filteredResults;
  }
}
